import { createContext } from 'react';

type Context = {
  index: number | null;
};

export const BoxSectionContext = createContext<Context>({
  index: null
});
